import { ProformaService } from 'app/services/operaciones/proforma/proforma.service';
import { DatePipe } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { Router } from '@angular/router';
import { FiltrosPropuestaOperacion } from 'app/models/FiltrosPropuestaOperacion';
import { MessagesTitles, MessagesGeneral, MessagesDates } from 'app/models/messages';
import { LoginService } from 'app/services/login/login.service';
import { PropuestaOperacionService } from 'app/services/operaciones/propuesta-operacion/propuesta-operacion.service';
import moment from 'moment';
import { Observable, Subscription } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { environment } from 'environments/environment';
import { GuiasService } from 'app/services/guias/guias.service';
import { resolveCreditoTipoServicioId } from 'app/shared/servifin-tipo-servicio.util';

export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY"
  }
};

declare var $: any;

@Component({
  selector: 'app-lista-evaluacion-operacion',
  templateUrl: './lista-evaluacion-operacion.component.html',
  styleUrls: ['./lista-evaluacion-operacion.component.scss'],
  providers: [MessagesTitles, MessagesGeneral, MessagesDates,
    DatePipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class ListaEvaluacionOperacionComponent implements OnInit, OnDestroy {

  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  Label_id_soles=environment.ID_GUIA_SOLES;
  Label_id_dolares=environment.ID_GUIA_DOLARES;
  Id_Confirming=environment.ID_CONFIRMING;
  Id_Factoring=environment.ID_FACTORING;
  Id_Credito: number | null = null;
  servifinMode = environment.SERVIFIN_MODE;
  idPropuestaOperacion: number;
  fechaDop: Date = new Date();
  fechaHop: Date = new Date();
  estado: string = "R";
  idProv = "";
  idAdq = "";
  user: any;
  form: FormGroup;
  ruc = new FormControl('');
  rucAdq = new FormControl('');
  filteredProveeedor: Observable<any[]>;
  proveedoresArr;
  filteredAdquirentes: Observable<any[]>;
  adquirentessArr;
  loading: boolean;
  arrPropuestaOperacion: any = [];
  docNegociables: any = [];
  dataSource: any;
  flagEvaluacion: boolean = false;
  estadoPropuesta: string = '';
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  DTOFiltrosPropuestaOperacion: FiltrosPropuestaOperacion = new FiltrosPropuestaOperacion();

  pageSizeOptions = [15, 20, 30, 50, 100, 200];
  displayedColumns: string[] = ['checked', 'idPropuestaOperacion', 'NombreComercialProv', 'Num_Doc_Identificacion_Prov', 'NombreComercialAdq', 'Num_Doc_Identificacion_Adq',
    'Registro', 'Tipo_Servicio_Dsc', 'TipoMoneda', 'VNPP', 'Comercial_Asociado', 'NroDocumentos', 'Estado'];
  subLista: Subscription[] = [];
  subPropOperacion: Subscription = new Subscription();
  idEncrip:any;
  constructor(
    private propuestaOperacionService: PropuestaOperacionService,
    private datePipe: DatePipe,
    private router: Router,
    private loginService: LoginService,
    private proformaService: ProformaService,
    private guiasService: GuiasService
  ) {
    this.DTOFiltrosPropuestaOperacion.FDesde = this.datePipe.transform(moment().add(-30, 'day'), 'yyyy-MM-dd');
    this.DTOFiltrosPropuestaOperacion.FHasta = this.datePipe.transform(moment(), 'yyyy-MM-dd');
    this.DTOFiltrosPropuestaOperacion.TipoServicio = '0';
    this.user = JSON.parse(sessionStorage.getItem('UserActive'));
    this.fechaDop.setDate(this.fechaDop.getDate() - 60);
    this.ObtenerProveedoresCombo();
    this.ObtenerAdquirentesCombo();
  }

  ngOnInit() {
    if (this.servifinMode) {
      this.guiasService.TipoServicio.subscribe(tipos => {
        this.Id_Credito = resolveCreditoTipoServicioId(tipos);
      });
    }
    this.ListadoEvaluacionOperacionFiltros();
  }

  ngOnDestroy() {
    this.subLista.forEach(sub => { sub.unsubscribe(); });
  }

  MetCerrarEvaluacionOperacion() {
    this.flagEvaluacion = false;
    this.ListadoEvaluacionOperacionFiltros();
  }

  ListadoEvaluacionOperacionFiltros() {
    this.loading = true;
    if (this.ruc.value == null || this.ruc.value == "") {
      this.idProv = "";
      this.DTOFiltrosPropuestaOperacion.RucProv = this.idProv;
    }
    if (this.rucAdq.value == null || this.rucAdq.value == "") {
      this.idAdq = "";
      this.DTOFiltrosPropuestaOperacion.RucAdq = this.idAdq;
    }
   /*  this.idEncrip=Buffer.from(this.user.id_user.toString()).toString('base64'); */
    this.DTOFiltrosPropuestaOperacion.user_id=this.idEncrip;
    this.DTOFiltrosPropuestaOperacion.FDesde = this.datePipe.transform(this.DTOFiltrosPropuestaOperacion.FDesde, 'yyyy-MM-dd');
    this.DTOFiltrosPropuestaOperacion.FHasta = this.datePipe.transform(this.DTOFiltrosPropuestaOperacion.FHasta, 'yyyy-MM-dd');

    this.subPropOperacion = this.propuestaOperacionService.ObtenerListaPropuestaOperacion(this.DTOFiltrosPropuestaOperacion).subscribe(
      res => {
        this.arrPropuestaOperacion = res;
        //console.log('propuesta',this.arrPropuestaOperacion)
        this.dataSource = new MatTableDataSource(this.arrPropuestaOperacion);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.loading = false;
      },
      err => {
        Swal.fire({
          title: "Datos incompletos",
          text: "Coordine con el departamento de contabilidad.",
          allowOutsideClick: true,
          heightAuto: false
        });
        this.loading = false;
      }
    );

    this.subLista.push(this.subPropOperacion);
  }

  private _filterProv(value: string): any[] {
    const filterValue = value.toString().toLowerCase();
    return this.proveedoresArr.filter(
      state => state.Razon_Social.toLowerCase().includes(filterValue) === true || 
      state.Num_Doc_Identificacion.toLowerCase().includes(filterValue) === true
    );
  }

  ObtenerProveedoresCombo() {
    this.proveedoresArr = JSON.parse(sessionStorage.getItem('lstProvCbo'));
    this.filteredProveeedor = this.ruc.valueChanges
      .pipe(
        startWith(""),
        map(state =>
          state ? this._filterProv(state) : this.proveedoresArr.slice()
        )
      );
  }

  ObtenerAdquirentesCombo() {
    this.adquirentessArr = JSON.parse(sessionStorage.getItem('lstAdqCbo'));
    this.filteredAdquirentes = this.rucAdq.valueChanges
      .pipe(
        startWith(""),
        map(state =>
          state ? this._filterAdq(state) : this.adquirentessArr.slice()
        )
      );
  }

  obtenerRucRazSocialAdq(termino: string = '') {
    if (termino != null && termino != '') {
      let termino1 = termino.toLowerCase();
      for (let p of this.adquirentessArr) {
        let raz = p.Razon_Social.toLocaleLowerCase();
        if (raz.indexOf(termino1) >= 0) {
          this.idAdq = p.Num_Doc_Identificacion;
        }
      }
    }
  }

  obtenerRucRazSocialProv(termino: string = '') {
    if (termino != null && termino != '') {
      let termino1 = termino.toLowerCase();
      for (let p of this.proveedoresArr) {
        let raz = p.Razon_Social.toLocaleLowerCase();
        if (raz.indexOf(termino1) >= 0) {
          this.idProv = p.Num_Doc_Identificacion;
        }
      }
    }
  }

  obtenerRucProv(termino: string) {
    this.idProv = termino;
    this.DTOFiltrosPropuestaOperacion.RucProv = this.idProv;
  }

  obtenerRucAdq(termino: string) {
    this.idAdq = termino;
    this.DTOFiltrosPropuestaOperacion.RucAdq = this.idAdq;
  }

  enviarIdPropuestaOP(propuestaOperacion: any) {
    this.idPropuestaOperacion = propuestaOperacion.idPropuestaOperacion;
    this.estadoPropuesta = propuestaOperacion.Estado;
    this.flagEvaluacion = true;
  }

  private _filterAdq(value: string): any[] {
    const filterValue = value.toString().toLowerCase();
    return this.adquirentessArr.filter(
      state => state.Razon_Social.toLowerCase().includes(filterValue) === true || 
      state.Num_Doc_Identificacion.toLowerCase().includes(filterValue) === true
    );
  }

  showNotification(type, from, align, message) {
    $.notify({
      icon: "notifications",
      message: message
    }, {
      type: type,
      timer: 4000,
      placement: {
        from: from,
        align: align
      },
      template: '<div data-notify="container" class="col-xl-4 col-lg-4 col-11 col-sm-4 col-md-4 alert alert-{0} alert-with-icon" role="alert">' +
        '<button mat-button  type="button" aria-hidden="true" class="close mat-button" data-notify="dismiss">  <i class="material-icons">close</i></button>' +
        '<i class="material-icons" data-notify="icon">notifications</i> ' +
        '<span data-notify="title">{1}</span> ' +
        '<span data-notify="message">{2}</span>' +
        '<div class="progress" data-notify="progressbar">' +
        '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
        '</div>' +
        '<a href="{3}" target="{4}" data-notify="url"></a>' +
        '</div>'
    });
  }

  detallePropuestaOperacion(elemento: any) {
    this.loginService.clickGuard = true;
    this.proformaService.flagEvaluacion = true;
    this.proformaService.datosPropuestaInformacion = elemento;
    this.router.navigate(["/operaciones/propuesta-operacion/detalle"]);
  }

}
